<template>

    <input type="number" class="form-control" v-model="handler" @input="change" >

</template>

<script>

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  mounted(){
      this.handler = this.value;
  },
  methods:{
    change(){
        this.$emit('change',this.handler);
    },
  }

}
</script>
